
export const getAlertRulesPending = () => {
    return {
        type: 'GET_ALERT_RULES_PENDING'
    }
};

export const getAlertRulesSuccess = (alertRules, page, pageCount, itemsCount) => {
    return {
        type: 'GET_ALERT_RULES_SUCCESS',
        alertRules,
        page,
        pageCount,
        itemsCount
    }
};

export const getAlertRulesError = error => {
    return {
        type: 'GET_ALERT_RULES_ERROR',
        error: error
    }
};

export const getAlertMessagesSuccess = (alertMessages) => {
    return {
        type: 'GET_ALERT_MESSAGES_SUCCESS',
        alertMessages
    }
};

export const getAlertMessagesError = error => {
    return {
        type: 'GET_ALERT_MESSAGES_ERROR',
        error: error
    }
};

export const getAlertMeasurementTypesSuccess = (alertMeasurementTypes) => {
    return {
        type: 'GET_ALERT_MEASUREMENT_TYPES_SUCCESS',
        alertMeasurementTypes
    }
};

export const getAlertMeasurementTypesError = error => {
    return {
        type: 'GET_ALERT_MEASUREMENT_TYPES_ERROR',
        error: error
    }
};

export const addAlertRuleSuccess = () => {
    return {
        type: 'ADD_ALERT_RULE_SUCCESS'
    }
};

export const addAlertRuleError = error => {
    return {
        type: 'ADD_ALERT_RULE_ERROR',
        error: error
    }
};

export const selectAlertRule = (alertRule) => {
    return {
        type: 'SELECT_ALERT_RULE',
        selected: { alertRule }
    };
};

export const getAlertRules = () => {

    return dispatch => {
        dispatch(getAlertRulesPending());

        fetch(`${process.env.REACT_APP_API_URL}/alert_rules_list`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getAlertRulesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                if (res.length) {
                    dispatch(selectAlertRule(res[0]))
                }
                dispatch(getAlertRulesSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getAlertMessages = () => {

    return dispatch => {
        dispatch(getAlertRulesPending());

        fetch(`${process.env.REACT_APP_API_URL}/alert_messages_list`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getAlertMessagesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                // if (res.length) {
                //     dispatch(selectAlertRule(res[0]))
                // }
                dispatch(getAlertMessagesSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const getAlertMeasurementTypes = () => {

    return dispatch => {
        dispatch(getAlertRulesPending());

        fetch(`${process.env.REACT_APP_API_URL}/alert_measurement_types_extended`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getAlertMeasurementTypesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                // if (res.length) {
                //     dispatch(selectAlertRule(res[0]))
                // }
                dispatch(getAlertMeasurementTypesSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};


export const updateThreshold = obj => {
    return dispatch => {
        dispatch(getAlertRulesPending());

        fetch(`${process.env.REACT_APP_API_URL}/update_alert_threshold`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj),
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getAlertRules());
                } else {
                    dispatch(getAlertRulesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const addRule = obj => {
    return dispatch => {
        dispatch(getAlertRulesPending());

        fetch(`${process.env.REACT_APP_API_URL}/new_alert_rule`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj),
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getAlertRules());
                } else {
                    dispatch(getAlertRulesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const updateRule = obj => {
    return dispatch => {
        dispatch(getAlertRulesPending());

        fetch(`${process.env.REACT_APP_API_URL}/update_alert_rule`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(obj),
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getAlertRules());
                } else {
                    dispatch(getAlertRulesError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};


